<template>
  <div class="list-space-outer">
    <a
      class="interactive button tertiary"
      @click="isLoggedIn ? goToWhyListWithUs() : showAction()"
    >
   <span v-if="isLoggedIn">List my space </span>
   <span v-else> {{ label }}</span>
     
    </a>
    <div class="inner list-space" v-if="showLoginDropDown" v-on:click="away()">
      <ul class="listing shortlists shortlists--custom">
        <li class="shortlist-action" @click="showLogin">
          <svg-icon id="signIn"></svg-icon>
          <span>Log In </span>
        </li>
        <li class="shortlist-action" @click="showSignup">
          <svg-icon id="signUp"></svg-icon>
          <span>Sign Up For Free</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: false,
      default: "List your space",
    },
  },
  data() {
    return {
      showLoginDropDown: false,
      triggeredAuth: false,
    };
  },
  mounted() {
    window.addEventListener("click", this.delegatedHideListYourSpace);
  },
  beforeDestroy() {
    window.removeEventListener("click", this.delegatedHideListYourSpace);
  },
  methods: {
    goToWhyListWithUs() {
      this.$store.dispatch("intercom/track", {
        type: "Visited List A Space",
      });
      window.location.href = "why-list-with-us";
    },
    showLogin() {
      this.triggeredAuth = true;
      this.$store.commit("user/changeAuthMode", "login");
    },
    showSignup() {
      this.triggeredAuth = true;
      this.$store.commit("user/changeAuthMode", "signup");
    },
    showAction() {
      this.showLoginDropDown = !this.showLoginDropDown;
    },
    away() {
      this.showLoginDropDown = false;
    },
    delegatedHideListYourSpace(e) {
      let target = e.target;

      while (target.parentNode) {
        if (target === this.$el) {
          return;
        }

        target = target.parentNode;
      }

      this.showLoginDropDown = false;
    },
  },
  computed: {
    authenticating() {},
    isLoggedIn() {
      var loggedInObj = this.$store.getters["user/account"];
      this.showLoginDropDown =
        typeof loggedInObj === "object" ? false : this.showLoginDropDown;
      return loggedInObj;
    },
  },
  watch: {
    authenticating(now) {
      if (!now && this.triggeredAuth && !this.isLoggedIn) {
        this.triggeredAuth = false;
      }
    },
    isLoggedIn(now) {
      if (now && this.triggeredAuth) {
        this.$store.commit("account/hide");
        this.triggeredAuth = false;
        this.showLoginDropDown = false;
      }
    },
  },
};
</script>
